import Spreadsheet, { Options as SpreadsheetOptions, SheetData } from "x-data-spreadsheet";

export class ShellExt extends Spreadsheet {
    constructor(selector:string | HTMLElement, options: SpreadsheetOptions) {
      super(selector, options);
    }

    private getDimensions(sheet:SheetData): SheetData {
        if (!sheet.rows) sheet.rows = {};
        const maxRowKey:number = Math.max(...Object.keys(sheet.rows).map((key)=>{ return Number(key)||0}));
        Object.assign(sheet.rows,{"len":Math.max(maxRowKey + 100, 1000)});
        if (!sheet.cols) {
            sheet.cols = {len:0};
        }
        let maxColKey:number = 0;
        Object.values(sheet.rows).forEach(row=>{
            if (row.cells) {
                maxColKey = Math.max(maxColKey,...Object.keys(row.cells).map((key)=>{ return Number(key)||0}));
            }
        });
        sheet.cols.len = Math.max(maxColKey + 100, 100);
        //@ts-ignore
        console.log(`Sheet ${sheet.name} has ${sheet.rows.len!} rows and ${sheet.cols.len} cols.`)
        return sheet;
    }

    override loadData(data: Record<string, any>): this {
        if (Array.isArray(data)) {
            return super.loadData(data.map(this.getDimensions));
        } else {
            return super.loadData(this.getDimensions(data));
        }
    }
}